import { useState } from "react";

export interface DemoTourStep {
  readonly caption: string;
  readonly onEnter?: () => void;
}

export function DemoTour({
  steps,
}: {
  readonly steps: readonly DemoTourStep[];
}) {
  const [stepIndex, setStepIndex] = useState<number | null>(null);

  if (steps.length === 0) {
    return null;
  }

  const enterStep = (index: number | null) => {
    setStepIndex(index);
    if (index !== null) {
      steps[index]?.onEnter?.();
    }
  };

  if (stepIndex === null) {
    return (
      <button
        className="tour-launch"
        type="button"
        onClick={() => enterStep(0)}
      >
        Tutorial
      </button>
    );
  }

  const isLastStep = stepIndex === steps.length - 1;

  return (
    <div aria-label="Guided setup tour" className="tour-overlay" role="group">
      <p aria-live="polite" className="tour-caption">
        Step {stepIndex + 1} of {steps.length} — {steps[stepIndex]?.caption}
      </p>
      <div className="tour-actions">
        <button
          type="button"
          onClick={() => enterStep(isLastStep ? null : stepIndex + 1)}
        >
          {isLastStep ? "Done" : "Next"}
        </button>
        {isLastStep ? null : (
          <button type="button" onClick={() => setStepIndex(null)}>
            Skip tour
          </button>
        )}
      </div>
    </div>
  );
}
